module.exports = __webpack_public_path__ + "97451ff33b8fea5a42d73081e0aa0ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/Bernadette.jpg
// module id = 836
// module chunks = 0